import i18n from "~/plugins/i18n";
import { baseTableConfig } from "~/utils/tables";
export default {
    ...baseTableConfig,
    fields: [
        {
            key: "_selected",
            label: "#",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
            fixed: true,
            _style: "width:5%",
        },
        {
            key: "id",
            label: "id",
            sorter: true,
            filter: false,
            fixed: true,
            active: true,
            _active: true,
            _filter: false,
            _type: "Integer",
        },
        {
            key: "name",
            label: "name",
            sorter: true,
            filter: true,
            active: true,
            _active: true,
            _filter: true,
            _style: "width:15%",
            _type: "Text",
        },
        {
            key: "active",
            label: "active",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: {
                active: false,
                value: null,
                condition: "is_equal_to",
                type: "select",
                options: [
                    { value: "1", label: i18n.t("active") },
                    { value: "0", label: i18n.t("disable") },
                ],
            },
            _style: "width:5%",
            _type: "Boolean",
        },
        {
            key: "clientName",
            label: "client",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: true,
            _style: "width:15%",
            _type: "String",
        },
        {
            key: "total",
            label: "total",
            active: true,
            _active: true,
            sorter: false,
            filter: false,
            _filter: false,
            _type: "Integer",
        },
        {
            key: "pending",
            label: "pending",
            active: true,
            _active: true,
            sorter: true,
            filter: false,
            _filter: false,
            _type: "Integer",
        },
        {
            key: "sent",
            label: "sent",
            active: true,
            _active: true,
            sorter: true,
            filter: false,
            _filter: false,
            _type: "Integer",
        },
        {
            key: "ok",
            label: "ok",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: false,
            _type: "Integer",
        },
        {
            key: "percent_ok",
            label: "ok_(%)",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _style: "width:5%",
            _filter: false,
            _type: "Number",
        },

        {
            key: "ko",
            label: "ko",
            sorter: true,
            filter: false,
            active: true,
            _active: true,
            _filter: false,
            _type: "Integer",
        },
        {
            key: "percent_ko",
            label: "ko_(%)",
            sorter: true,
            filter: false,
            active: true,
            _active: true,
            _filter: false,
            _style: "width:5%",
            _type: "Number",
        },
        {
            key: "duplicate",
            label: "duplicates",
            sorter: true,
            filter: false,
            active: true,
            _active: true,
            _filter: false,
            _type: "Integer",
        },
        {
            key: "percent_duplicate",
            label: "duplicates_(%)",
            sorter: true,
            filter: false,
            active: true,
            _active: true,
            _filter: false,
            _style: "width:5%",
            _type: "Number",
        },
        {
            key: "error",
            label: "error",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: false,
            _type: "Integer",
        },
        {
            key: "percent_error",
            label: "error_(%)",
            sorter: true,
            filter: false,
            active: true,
            _active: true,
            _filter: false,
            _style: "width:5%",
            _type: "Number",
        },
        {
            key: "added_at",
            label: "Added at",
            sorter: false,
            filter: false,
            active: true,
            _active: true,
            _filter: false,
            _style: "width:10%",
            _type: "Date",
        },
    ],

    sorter: {
        external: true,
        resetable: true,
    },
    sorterValue: {
        column: null,
        asc: true,
    },
};
